import React, { Component } from "react";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    toast,
    ToastContainer,
    MDBIcon,
    MDBInput,
} from "mdbreact";
import Navigation from "../../../components/SubscriberMgmt/Navigation/Navigation";
import KeyInformation from "../../../components/SubscriberMgmt/KeyInformation/KeyInformation";
import DeviceInformation from "../../../components/SubscriberMgmt/DeviceInformation/DeviceInformation";
import MessagesDashboard from "../../../components/SubscriberMgmt/Messages/MessagesDashboard";
import CumulativeBandwidth from "../../../components/SubscriberMgmt/CumulativeBandwidth/CumulativeBandwidth";
import Upgrade from "../../../components/SubscriberMgmt/Upgrade/SelectPlan";
import UpgradeReview from "../../../components/SubscriberMgmt/Upgrade/Review";
import UpgradeCheckout from "../../../components/SubscriberMgmt/Upgrade/CheckOut";
import UpgradePaymentSuccess from "../../../components/SubscriberMgmt/Upgrade/PaymentSuccess";
import Cancel from "../../../components/SubscriberMgmt/Cancel/Cancel";
import axios from "../../../axios";
import parse from "html-react-parser";
import { withTranslation } from "react-i18next";
// import Joyride from "react-joyride";
import MyAccount from "../../../assets/images/myAccountSub.png";
import LogoFooter from "../../../components/Logo/logoFooter";
import brandsData from "../../../brands/common/brands.json";
import _ from "lodash";
import "./SupportChat.css";
const API_Server = "https://tools.roamingiq.com:3002";
class DashboardSubscriber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SessionList: [],
            venueName: [],
            keyNameListArray: null,
            loading: true,
            keys: undefined,
            modalMessage: true,
            messages: {},
            devices: [],
            isTourOpen: false,
            darkmode: JSON.parse(localStorage.getItem("darkMode")),
            selectedNetworkIndex: 0,
            selectedKeyName: null,
            paymentFailed: false,
            showError: false,
            keyNameArray: {},
            isUbiquiti: false,
            // Support Chat state variables
            supportChatOpen: false,
            conversationId: null,
            currentState: null,
            chatMessages: [],
            messageInput: '',
            sendButtonDisabled: false,
            startButtonDisabled: false,
            chatInputVisible: false,
            conversationInfoVisible: false,
            typingIndicatorVisible: false,
            errorMessage: '',
            errorVisible: false
        };
    }
    componentDidMount() {
        this.listKeys();
        document.title = "My Wi-Fi Network Dashboard";
        this.getDisplayOptions();
    }
    getDisplayOptions = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/listOperatorDetails",
                body,
                {
                    headers: { "api-version": "20260417" },
                }
            )
            .then((response) => {
                // console.log("theme changed")
                let theme;
                if (
                    localStorage.getItem("darkMode") === "false" ||
                    localStorage.getItem("darkMode") === null
                ) {
                    theme = "ThemeLight";
                } else {
                    theme = "ThemeDark";
                }
                // root?.style.setProperty(
                //     "--background-color",
                //     response.data.DisplayConfiguration[theme][
                //         "BackgroundColorHex"
                //     ]
                // );
                // root?.style.setProperty(
                //     "--modal-background-color",
                //     response.data.DisplayConfiguration[theme]["ModalColorHex"]
                // );
                // root?.style.setProperty(
                //     "--primary-text-color",
                //     response.data.DisplayConfiguration[theme][
                //         "PrimaryTextColorHex"
                //     ]
                // );
                // root?.style.setProperty(
                //     "--primary-color",
                //     response.data.DisplayConfiguration[theme]["PrimaryColorHex"]
                // );
                // root?.style.setProperty(
                //     "--secondary-color",
                //     response.data.DisplayConfiguration[theme][
                //         "SecondaryColorHex"
                //     ]
                // );
                // root?.style.setProperty("--border-color", "#BFBFBF");
                // root?.style.setProperty(
                //     "--primary-color-rgb",
                //     response.data.DisplayConfiguration[theme][
                //         "PrimaryColorHex"
                //     ] + "4D"
                // );
                // root?.style.setProperty(
                //     "--button-color",
                //     response.data.DisplayConfiguration[theme]["PrimaryColorHex"]
                // );
                // root?.style.setProperty("--button-text-color", "#FFF");
                // root?.style.setProperty(
                //     "--summary-card-color",
                //     response.data.DisplayConfiguration[theme][
                //         "SecondaryColorHex"
                //     ]
                // );
                // root?.style.setProperty(
                //     "--navbar-text-color",
                //     response.data.DisplayConfiguration[theme][
                //         "PrimaryTextColorHex"
                //     ]
                // );
                // root?.style.setProperty(
                //     "--navbar-color",
                //     response.data.DisplayConfiguration[theme]["NavbarColorHex"]
                // );
                // root?.style.setProperty(
                //     "--card-color",
                //     response.data.DisplayConfiguration[theme]["NavbarColorHex"]
                // );
                // root?.style.setProperty(
                //     "--input-color",
                //     response.data.DisplayConfiguration[theme][
                //         "InputBoxColorHex"
                //     ]
                // );
                // root?.style.setProperty(
                //     "--input-focus-color",
                //     response.data.DisplayConfiguration[theme]["BannerColor2Hex"]
                // );
                this.setState({
                    s3Directory:
                        response.data.DisplayConfiguration["Behavior"][
                            "S3Directory"
                        ],
                    logo: response.data.DisplayConfiguration[theme][
                        "LogoFileNameDesktopMobileAfterLogin"
                    ],
                    displayOptionID: response.data.DisplayOptionID,
                    operatorName: response.data.NetworkOperatorName,
                    cancelInputType:
                        response.data["DisplayConfiguration"]["Behavior"][
                            "CancellationMethod"
                        ],
                    showUpdate:
                        response.data["DisplayConfiguration"]["ShoppingCart"][
                            "AllowSelfPaymentMethodUpdate"
                        ],
                    showSupport:
                        response.data.DisplayConfiguration["Support"][
                            "ShowSupportLinks"
                        ],
                    externalSupport:
                        response.data.DisplayConfiguration["Support"][
                            "ExternallyManagedSupport"
                        ],
                    externalSupportLink:
                        response.data.DisplayConfiguration["Support"][
                            "ExternalSupportSystemURL"
                        ],
                    showDevices:
                        response.data.DisplayConfiguration[
                            "ShowEquipmentStatusToVenueAdministrator"
                        ],
                    showCancel: response.data.DisplayConfiguration["ShoppingCart"]["AllowSelfCancellation"],
                    // globalNetworkConfiguration: response.data["NetworkConfiguration"],
                    // globalMessagingConfiguration: response.data["Notifications"],
                    // globalRealPageConfiguration: response.data["PMS"],
                    // globalShoppingCartConfiguration: response.data["ShoppingCart"],
                    // allowOverlapping:
                    //   response.data["NetworkConfiguration"][
                    //     "allowOverlappingSubscriptionWiredUnit"
                    //   ],
                    // selectDefaultServicePlanResident:
                    //   response.data["ServicePlanConfiguration"][
                    //     "DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess"
                    //   ],
                    // selectDefaultServicePlanWireless:
                    //   response.data["ServicePlanConfiguration"][
                    //     "DefaultServicePlanID_LocalWirelessAccess"
                    //   ],
                    // globalKeyPoolList:
                    //   response.data["NetworkConfiguration"]["GlobalSSID"],
                    operatorID: response.data["OperatorID"],
                });
                sessionStorage.setItem(
                    "cancelInputType",
                    response.data.DisplayConfiguration["Behavior"][
                        "CancellationMethod"
                    ]
                );
                sessionStorage.setItem(
                    "showUpgrade",
                    response.data.DisplayConfiguration["ShoppingCart"][
                        "AllowSelfServicePlanUpdate"
                    ]
                );
                sessionStorage.setItem(
                    "showUpdate",
                    response.data.DisplayConfiguration["ShoppingCart"][
                        "AllowSelfPaymentMethodUpdate"
                    ]
                );
                sessionStorage.setItem(
                 "showCustomPSK",
                 response.data.NetworkConfiguration[
                     "CustomPSK"
                 ]
                );
                sessionStorage.setItem("loggedInNO", true);
            })
            .catch((error) => {});
    };
    handleSwitchChange = (nr) => () => {
        this.setState({
            darkmode: !JSON.parse(this.state.darkmode),
        });
        localStorage.setItem("darkMode", !JSON.parse(this.state.darkmode));
        let element = document.getElementsByTagName("body")[0];
        element.setAttribute(
            "data-theme",
            "darkMode-" + !JSON.parse(this.state.darkmode)
        );
        this.getDisplayOptions();
    };
    
    updateMessageStatus = (messageID) => {
        // Update only the specific message to mark it as read without refreshing the entire dashboard
        this.setState(prevState => {
            const updatedMessages = { ...prevState.messages };
            if (updatedMessages[messageID]) {
                updatedMessages[messageID] = {
                    ...updatedMessages[messageID],
                    newMessage: false
                };
            }
            return { messages: updatedMessages };
        });
    };
    
    listKeys = () => {
        this.setState({ loading: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            // IdToken: sessionStorage.getItem("IdToken"),
        };
        let keysAndVenueUnitPolicies = {};
        let keysAndVenueUnitPoliciesArray = [];
        let bodySessions = [];
        let iterationSessions = 0;
        let updatedSessions = [];
        let keys1;
        let keys2 = [];
        let updatedKeys = {};
        let suffixForSSID = "";
        axios
            .post("/subscriberconsole/listKeys", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                sessionStorage.setItem("subscriberManagedviaSSO", response.data.SubscriberManagedviaSSO);
                this.setState({
                    devices: [],
                    listKeysResponse: response.data,
                });
                this.setState({ keys: [] });
                keys1 = response.data.KeysInKeyPools;
                this.setState({
                    subscriberToken: response.data.SubscriberToken,
                });
                // let venueList = Object.keys(response.data.KeysInKeyPools);
                if (
                    Object.values(keys1).findIndex(
                        (item) => item.ssid.toLowerCase() === "login to view"
                    ) === -1
                ) {
                    _.merge(updatedKeys, keys1);
                    for (let i = 0; i < Object.keys(keys1).length; i++) {
                        if (
                            keys1[Object.keys(keys1)[i]].ssid.toLowerCase() ===
                            "login to view"
                        ) {
                            // updatedKeys[Object.keys(keys1)[i]] = keys1[Object.keys(keys1)[i]]
                            // console.log(updatedKeys)
                            // console.log(Object.keys(keys1)[i])
                            keys2 = keys1[Object.keys(keys1)[i]];
                        }
                    }
                } else {
                    this.setState({
                     isUbiquiti : true
                    })
                    for (let i = 0; i < Object.keys(keys1).length; i++) {
                        if (
                            keys1[Object.keys(keys1)[i]].ssid.toLowerCase() ===
                            "login to view"
                        ) {
                            updatedKeys[Object.keys(keys1)[i]] =
                                keys1[Object.keys(keys1)[i]];
                            // console.log(updatedKeys)
                            // console.log(Object.keys(keys1)[i])
                            keys2 = keys1[Object.keys(keys1)[i]];
                        }
                    }
                    for (let k = 0; k < Object.keys(keys2).length; k++) {
                        if (
                            Object.keys(keys2)[k] !== "DisplayOrder" &&
                            Object.keys(keys2)[k] !== "ssid" && 
                            Object.keys(keys2)[k] !== "AuthenticationMechanism" && 
                            Object.keys(keys2)[k] !== "editable"
                        ) {
                            // console.log(keys2[Object.keys(keys2)[k]]['psk'])
                            let keytagname = Object.keys(keys2)[k];
                            // console.log(keytagname)
                            // let randomString = crypto.pbkdf2Sync(keys2[Object.keys(keys2)[k]]['psk'],'unifi', 4096, 32, "sha1").toString("hex");
                            // console.log(randomString)
                            const obj = keys2;
                            Object.defineProperty(
                                obj,
                                keytagname,
                                Object.getOwnPropertyDescriptor(obj, keytagname)
                            );
                            // delete keys2[keytagname];
                        }
                        const ssid = "login to view";
                        keys2 = { ...keys2, ssid };
                    }
                    updatedKeys["Ubiquiti5g"] = keys2;
                }
                for (let m = 0; m < Object.keys(updatedKeys).length; m++) {
                    let objectNumber = Object.keys(updatedKeys)[m];
                    let unitIDforSSID;
                    if (
                        updatedKeys[objectNumber]["ssid"].toLowerCase() ===
                        "login to view"
                    )
                        for (
                            let n = 0;
                            n < Object.keys(updatedKeys[objectNumber]).length;
                            n++
                        ) {
                            let indexNumber = Object.keys(
                                updatedKeys[objectNumber]
                            )[n];
                            if (
                                indexNumber !== "ssid" &&
                                indexNumber !== "DisplayOrder" &&
                                indexNumber !== "AuthenticationMechanism" &&
                                indexNumber !== "editable"
                            ) {
                                let venueUnitPolicyIDforSSID = Object.keys(
                                    updatedKeys[objectNumber][indexNumber][
                                        "VenueUnitPolicies"
                                    ]
                                );
                                if (
                                    updatedKeys[objectNumber][
                                        "ssid"
                                    ].toLowerCase() === "login to view"
                                )
                                    unitIDforSSID =
                                        updatedKeys[
                                            Object.keys(updatedKeys)[m]
                                        ][indexNumber]["VenueUnitPolicies"][
                                            venueUnitPolicyIDforSSID
                                        ]["UnitID"];
                                suffixForSSID =
                                    " " +
                                    updatedKeys[Object.keys(updatedKeys)[m]][
                                        indexNumber
                                    ]["VenueUnitPolicies"][
                                        venueUnitPolicyIDforSSID
                                    ]["VenueAddressLine2"];
                                // console.log(unitIDforSSID)
                            }
                            // console.log(unitIDforSSID)
                            if (
                                unitIDforSSID !== undefined &&
                                updatedKeys[objectNumber][
                                    "ssid"
                                ].toLowerCase() === "login to view"
                            ) {
                                if (objectNumber === "Ubiquiti5g") {
                                    const ssid = unitIDforSSID + suffixForSSID;
                                    const DisplayOrder = "10";
                                    updatedKeys[objectNumber] = {
                                        ...updatedKeys[objectNumber],
                                        ssid,
                                        DisplayOrder,
                                    };
                                } else {
                                    const ssid = unitIDforSSID;
                                    const DisplayOrder = "50";
                                    updatedKeys[objectNumber] = {
                                        ...updatedKeys[objectNumber],
                                        ssid,
                                        DisplayOrder,
                                    };
                                }
                            }
                        }
                }
                // console.log(updatedKeys)
                var sortedKeys = _(updatedKeys)
                    .map(function (v, k) {
                        // insert the key into the object
                        return _.merge({}, v, { key: k });
                    })
                    .sortBy("DisplayOrder") // sort by name
                    .value();
                console.log("sortedKeys", sortedKeys)
                console.log("sortedKeys length:", sortedKeys.length);
                this.setState({ venueList: Object.keys(updatedKeys) });
                this.setState({ keys: [updatedKeys] });
                this.setState({ sortedKeys: sortedKeys });
                this.setState({ venueName: this.state.venueList });
                this.setState({
                    // devices: response.data.AllDevices,
                    // deviceCountOffline: response.data.DeviceCountOffline,
                    // deviceCountOnline: response.data.DeviceCountOnline,
                    messages: response.data.messages_from_venues,
                    allData: response.data,
                    token: response.data.SubscriberToken,
                });
                this.getDevices(response.data.SubscriberToken);
                sessionStorage.setItem(
                    "emailSubscriber",
                    response.data.EmailAddress
                );
                sessionStorage.setItem(
                    "phoneNumberSubscriber",
                    response.data["PhoneNumber.E164"]
                );
                sessionStorage.setItem("firstName", response.data.GivenName);
                sessionStorage.setItem("lastName", response.data.FamilyName);
                let keyNameArray = [];
                let keyNameListArray = [];
                let keyNameListArrayAll = [];
                let allVenueUnitPolicies = {};
                var obj = {};
                var obj_all = {};
                for (let i = 0; i < sortedKeys.length; i++) {
                    keyNameArray.push(sortedKeys[i]);
                    obj[i] = {};
                    let keyNameList = Object.keys(sortedKeys[i]);
                    // console.log(keyNameList)
                    for (
                        let j = 0;
                        j < Object.keys(sortedKeys[i]).length;
                        j++
                    ) {
                        let keyPoolID = keyNameList[j];
                        if (
                            sortedKeys[i][keyPoolID]["KeyTag"] !==
                            undefined
                        ) {
                            // console.log(sortedKeys[i][keyPoolID]["VenueUnitPolicies"])
                            this.setState({
                                venueUnitPolicies:
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ],
                            });
                            // console.log(sortedKeys[i][keyPoolID]["VenueUnitPolicies"])
                            for (
                                let j = 0;
                                j <=
                                Object.keys(
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ]
                                ).length;
                                j++
                            ) {
                                // console.log(sortedKeys[i][keyPoolID]["VenueUnitPolicies"])
                                // allVenueUnitPolicies.push(sortedKeys[i][keyPoolID]["VenueUnitPolicies"][j])
                            }
                            // console.log("keyPoolID", keyPoolID)
                            // for (const value of Object.values(
                            //     sortedKeys[i][keyPoolID]
                            // )) {
                            //     // console.log(value);
                            //     // allVenueUnitPolicies.push(value)
                            // }
                            // Create unique key to avoid duplicates - append pool index if key already exists
                            let uniqueKeyID = keyPoolID;
                            if (allVenueUnitPolicies[keyPoolID]) {
                                uniqueKeyID = keyPoolID + "_pool" + i;
                            }
                            allVenueUnitPolicies[uniqueKeyID] = {
                                ...sortedKeys[i][keyPoolID],
                                originalKeyID: keyPoolID  // Preserve original key ID
                            };
                            obj[i][keyPoolID] = 0;
                            obj[i][keyPoolID] =
                                sortedKeys[i][keyPoolID]["KeyTag"];
                            obj_all[i] = sortedKeys[i][keyPoolID];
                            obj_all[i].keyTag = keyPoolID;
                            obj_all[i].network =
                                sortedKeys[i]["ssid"];
                            obj_all[i].selectedNetworkIndex = i;
                            let venueUnitPolicyID = Object.keys(
                                sortedKeys[i][keyPoolID][
                                    "VenueUnitPolicies"
                                ]
                            );
                            obj_all[i].venueID =
                                sortedKeys[i][keyPoolID][
                                    "VenueUnitPolicies"
                                ][venueUnitPolicyID[0]]["VenueID"];
                            obj_all[i].servicePlanID =
                                sortedKeys[i][keyPoolID][
                                    "VenueUnitPolicies"
                                ][venueUnitPolicyID[0]]["ServicePlan"][
                                    "ServicePlanID"
                                ];
                            // this.setState({
                            // 	paymentFailed:
                            // 		sortedKeys[i][keyPoolID][
                            // 			"VenueUnitPolicies"
                            // 		][venueUnitPolicyID[0]]["paymentFailed"],
                            // });
                            if (
                                !sortedKeys[i][keyPoolID][
                                    "wpa2enterprise_auth"
                                ]
                            ) {
                                this.setState({
                                    paymentFailed:
                                        sortedKeys[i][keyPoolID][
                                            "VenueUnitPolicies"
                                        ][venueUnitPolicyID[0]][
                                            "paymentFailed"
                                        ],
                                });
                                sessionStorage.setItem(
                                    "venueIDSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["VenueID"]
                                );
                                sessionStorage.setItem(
                                    "venueNameSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["VenueName"]
                                );
                                sessionStorage.setItem(
                                    "stripeClientSecretSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]][
                                        "StripeClientSecret"
                                    ]
                                );
                                sessionStorage.setItem(
                                    "unitID_internalSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["UnitID_internal"]
                                );
                                sessionStorage.setItem(
                                    "servicePlanIDSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["ServicePlan"][
                                        "ServicePlanID"
                                    ]
                                );
                                sessionStorage.setItem(
                                    "servicePlanNameSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["ServicePlan"][
                                        "ServicePlanName"
                                    ]
                                );
                                sessionStorage.setItem(
                                    "servicePlanNameSubscriber",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["ServicePlan"][
                                        "ServicePlanName"
                                    ]
                                );
                                sessionStorage.setItem(
                                    "address",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["AddressLine1"]
                                );
                                sessionStorage.setItem(
                                    "city",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["City"]
                                );
                                sessionStorage.setItem(
                                    "state",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["State"]
                                );
                                sessionStorage.setItem(
                                    "postalcode",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["PostalCode"]
                                );
                                sessionStorage.setItem(
                                    "unit",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["UnitID_internal"]
                                );
                                sessionStorage.setItem(
                                    "unitName",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]]["UnitID"]
                                );
                                sessionStorage.setItem(
                                    "dateStart",
                                    sortedKeys[i][keyPoolID][
                                        "VenueUnitPolicies"
                                    ][venueUnitPolicyID[0]][
                                        "StartDateTimeUTC.ISO8601"
                                    ]
                                );
                            //     sessionStorage.setItem(
                            //      "cancelInputType",
                            //      sortedKeys[i][keyPoolID][
                            //               "VenueUnitPolicies"
                            //           ][venueUnitPolicyID[0]]["DisplayConfiguration"]["Behavior"][
                            //          "CancellationMethod"
                            //      ]
                            //  );
                            //  sessionStorage.setItem(
                            //      "showUpgrade",
                            //      sortedKeys[i][keyPoolID][
                            //       "VenueUnitPolicies"
                            //   ][venueUnitPolicyID[0]]["DisplayConfiguration"]["ShoppingCart"][
                            //          "AllowSelfServicePlanUpdate"
                            //      ]
                            //  );
                            //  sessionStorage.setItem(
                            //      "showUpdate",
                            //      sortedKeys[i][keyPoolID][
                            //       "VenueUnitPolicies"
                            //   ][venueUnitPolicyID[0]]["DisplayConfiguration"]["ShoppingCart"][
                            //          "AllowSelfPaymentMethodUpdate"
                            //      ]
                            //  );
                                // sessionStorage.setItem(
                                //     "logoURL",
                                //     this.state.sortedKeys[i][keyPoolID][
                                //         "VenueUnitPolicies"
                                //     ][venueUnitPolicyID[0]]["DisplayOptions"][
                                //         "LogoPNG.URL"
                                //     ]
                                // );
                                // sessionStorage.setItem(
                                //     "supportEmail",
                                //     this.state.sortedKeys[i][keyPoolID][
                                //         "VenueUnitPolicies"
                                //     ][venueUnitPolicyID[0]]["DisplayOptions"][
                                //         "VenueSupportEmailAddress"
                                //     ]
                                // );
                                // sessionStorage.setItem(
                                //     "supportPhone",
                                //     this.state.sortedKeys[i][keyPoolID][
                                //         "VenueUnitPolicies"
                                //     ][venueUnitPolicyID[0]]["DisplayOptions"][
                                //         "VenueSupportPhoneNumber.E164"
                                //     ]
                                // );
                            }
                        }
                    }
                }
                // console.log("keyNameArray", keyNameArray);
                keyNameListArrayAll.push(obj_all);
                keyNameListArray.push(obj);
                // console.log(obj_all)
                // console.log("keyNameListArrayAll", keyNameListArrayAll)
                //  const uniqueOptionVenueUnitPolicy = this.removeDuplicates(
                //   allVenueUnitPolicies,
                //   "UnitID_internal"
                // );
                
                // Set initial selected key to first key in the first network
                let initialSelectedKeyName = null;
                console.log("sortedKeys", sortedKeys);
                if (sortedKeys && sortedKeys.length > 0 && sortedKeys[0]) {
                    const firstNetworkKeys = Object.keys(sortedKeys[0]);
                    const firstKeyID = firstNetworkKeys.find(key => key !== 'ssid' && key !== 'DisplayOrder' && key !== 'AuthenticationMechanism' && key !== 'key' && key !== 'editable');
                    if (firstKeyID && sortedKeys[0][firstKeyID] && sortedKeys[0][firstKeyID]["KeyTag"]) {
                        initialSelectedKeyName = sortedKeys[0][firstKeyID]["KeyTag"];
                    }
                    console.log("firstNetworkKeys", firstNetworkKeys);
                }
                this.setState({ 
                    keyNameListArray: keyNameListArray,
                    keyNameListArrayAll: keyNameListArrayAll,
                    keyNameArray: keyNameArray,
                    selectedKeyName: initialSelectedKeyName,
                    selectedNetworkIndex: 0
                });
                // this.setState({ allVenueUnitPolicies: uniqueOptionVenueUnitPolicy});
                // console.log("allVenueUnitPolicies", allVenueUnitPolicies)
                Object.keys(allVenueUnitPolicies).forEach((oneKey, i) => {
                    // console.log(oneKey)
                    keysAndVenueUnitPolicies[i] = 0;
                    // keysAndVenueUnitPoliciesArray.push(oneKey)
                    Object.keys(
                        allVenueUnitPolicies[oneKey]["VenueUnitPolicies"]
                    ).forEach((twoKey, j) => {
                        keysAndVenueUnitPolicies[i] = {
                            ...keysAndVenueUnitPolicies[i],
                            keyTag: oneKey,
                            venueUnitPolicyID: twoKey,
                        };
                        // console.log(keysAndVenueUnitPolicies)
                        keysAndVenueUnitPoliciesArray.push({
                            VenueUnitPolicyID: twoKey,
                            SSID: allVenueUnitPolicies[oneKey]["network"],
                            Profile: allVenueUnitPolicies[oneKey]["KeyTag"],
                            PSK: allVenueUnitPolicies[oneKey]["psk"],
                            UnitID: allVenueUnitPolicies[oneKey][
                                "VenueUnitPolicies"
                            ][twoKey]["UnitID"],
                            UnitBuilding:
                                allVenueUnitPolicies[oneKey][
                                    "VenueUnitPolicies"
                                ][twoKey]["UnitBuilding"],
                            UnitFloor:
                                allVenueUnitPolicies[oneKey][
                                    "VenueUnitPolicies"
                                ][twoKey]["UnitFloor"],
                            VenueName:
                                allVenueUnitPolicies[oneKey][
                                    "VenueUnitPolicies"
                                ][twoKey]["VenueName"],
                            keyID: oneKey,
                        });
                        // keysAndVenueUnitPolicies[i][j] = allVenueUnitPolicies[oneKey]["VenueUnitPolicies"]
                    });
                });
                this.setState({
                    keysAndVenueUnitPoliciesArray:
                        keysAndVenueUnitPoliciesArray,
                });
                const sessionList = sortedKeys;
                console.log("sessionList", sessionList);
                let SessionListID = null;
                let newSessionList = [];
                bodySessions.push(sessionList);
                bodySessions.forEach((val) => {
                    SessionListID = Object.keys(bodySessions[0]);
                });
                SessionListID.forEach((val, index) => {
                    updatedSessions = bodySessions.map((sessionList) => {
                        return {
                            ...sessionList[SessionListID[iterationSessions]],
                        };
                    });
                    if (updatedSessions[0] !== undefined) {
                        newSessionList.push(updatedSessions);
                        iterationSessions = iterationSessions + 1;
                    }
                });
                this.setState({ SessionList: newSessionList });
                if (this.state.keys !== undefined) {
                    this.setState({ loading: false });
                }
                if (this.state.keyNameArray.length !== 0) {
                    this.getServicePlans();
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                this.setState({ showError: true });
                this.setState({ error: error });
            });
    };
    getDevices = (subscriberToken) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SubscriberToken: subscriberToken,
        };
        axios
            .post("/operatorconsole/subscribers/listDevices", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                this.setState({
                    devices: response.data.Devices,
                    deviceCountOffline: response.data.DeviceCountOffline,
                    deviceCountOnline: response.data.DeviceCountOnline,
                });
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    }
    removeDuplicates(arr, prop) {
        return arr.filter(
            (obj, index, self) =>
                index === self.findIndex((o) => o[prop] === obj[prop])
        );
    }
    getServicePlans = () => {
        let selectedKeyID;
        let servicePlanID;
        let filteredServicePlans = [];
        let billingCycleHours;
        let billingCycleRecurrance;
        let billingCyclePrice;
        for (
            let i = 0;
            i <
            Object.keys(
                this.state.keyNameArray[this.state.selectedNetworkIndex]
            ).length;
            i++
        ) {
            if (
                Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i] !== "DisplayOrder" &&
                Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i] !== "ssid" &&
                Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i] !== "key" &&
                Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i] !== "AuthenticationMechanism" &&
                Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i] !== "editable"
            ) {
                selectedKeyID = Object.keys(
                    this.state.keyNameArray[this.state.selectedNetworkIndex]
                )[i];
                servicePlanID =
                    this.state.keyNameArray[this.state.selectedNetworkIndex][
                        selectedKeyID
                    ]["servicePlanID"];
            }
        }
        let body;
        if (sessionStorage.getItem("unit") !== null) {
            body = {
                UnitID_internal: sessionStorage.getItem("unit"),
            };
        } else {
            body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                VenueID: sessionStorage.getItem("venueID"),
            };
        }
        axios
            .post(
                "/networkoperatorconsole/shoppingcart/listServicePlans",
                body,
                {
                    headers: { "api-version": "20260417" },
                }
            )
            .then((response) => {
             sessionStorage.setItem(
                "currencyNames", response.data["AvailableServicePlans"][0].Currencies[0]) 
             const firstCurrencyValue = sessionStorage.getItem("currencyNames");
                let sortedServicePlans = _(response.data.AvailableServicePlans)
                    .map(function (v, k) {
                        // insert the key into the object
                        return _.merge({}, v, { key: k });
                    })
                    .sortBy("BillingCyclePrice."+firstCurrencyValue) // sort by price
                    .reverse() // sort by name
                    .value();
                for (let i = 0; i < sortedServicePlans.length; i++) {
                    if (
                        sortedServicePlans[i]["ServicePlanID"] ===
                        sessionStorage.getItem("servicePlanIDSubscriber")
                    ) {
                        sessionStorage.setItem(
                            "servicePlanPriceSubscriber",
                            sortedServicePlans[i]["BillingCyclePrice."+firstCurrencyValue] / 100
                        );
                        sessionStorage.setItem(
                            "billingCycleHours",
                            sortedServicePlans[i]["BillingCycleHours"]
                        );
                        sessionStorage.setItem(
                            "BillingCycleRecurrence",
                            sortedServicePlans[i]["BillingCycleRecurrence"]
                        );
                        billingCycleHours =
                            sortedServicePlans[i]["BillingCycleHours"];
                        billingCycleRecurrance =
                            sortedServicePlans[i]["BillingCycleRecurrence"];
                        billingCyclePrice =
                            sortedServicePlans[i]["BillingCyclePrice."+firstCurrencyValue];
                        this.setState({
                            ServicePlanName:
                                sortedServicePlans[i]["ServicePlanName"],
                            BillingCyclePrice:
                                sortedServicePlans[i]["BillingCyclePrice."+firstCurrencyValue] /
                                100,
                            BillingCycleHours:
                                sortedServicePlans[i]["BillingCycleHours"],
                        });
                    }
                }
                // console.log(billingCyclePrice)
                for (let i = 0; i < sortedServicePlans.length; i++) {
                    if (
                        sortedServicePlans[i]["BillingCycleHours"] ===
                            billingCycleHours &&
                        sortedServicePlans[i]["BillingCycleRecurrence"] ===
                            billingCycleRecurrance &&
                        sortedServicePlans[i]["BillingCyclePrice."+firstCurrencyValue] !==
                            billingCyclePrice
                    ) {
                        filteredServicePlans.push(sortedServicePlans[i]);
                    }
                    sessionStorage.setItem(
                        "AvailableServicePlans",
                        JSON.stringify(filteredServicePlans)
                    );
                    sessionStorage.setItem(
                        "AvailableServicePlanCount",
                        filteredServicePlans.length
                    );
                }
                for (let i = 0; i < filteredServicePlans.length; i++) {
                    // console.log(servicePlanID)
                    if (
                        filteredServicePlans[i]["ServicePlanID"] ===
                        servicePlanID
                    ) {
                    }
                    // console.log(filteredServicePlans[i]["BillingCyclePrice.USD"])
                    // console.log(billingCyclePrice)
                    if (
                        filteredServicePlans[i]["BillingCyclePrice."+firstCurrencyValue] >
                        billingCyclePrice
                    ) {
                        this.setState({
                            UpgradeServicePlanName:
                                filteredServicePlans[i]["ServicePlanName"],
                            UpgradeBillingCyclePrice:
                                filteredServicePlans[i][
                                    "BillingCyclePrice."+firstCurrencyValue
                                ] / 100,
                        });
                    }
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                this.setState({ error: error });
            });
    };
    getNotifications = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post("/operatorconsole/subscribers/listNotifications", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                this.setState({
                    devices: response.data.Devices,
                    deviceCountOffline: response.data.DeviceCountOffline,
                    deviceCountOnline: response.data.DeviceCountOnline,
                });
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    };

    toggleMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
    };
    toggleNotifications = () => {
        this.setState({ toggleNotifications: "toggledOff" });
    };
    submitConfirmMessage = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            MessageID: index,
        };
        axios
            .post("/subscriberconsole/acknowledgeMessageFromVenue", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                toast.success("Message Read!", {
                    closeButton: false,
                });
                this.listKeys();
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    };
    closeTour2 = () => {
        this.setState({
            isTourOpen: !this.state.isTourOpen,
        });
    };
    closeTour = () => {
        this.setState({
            isTourOpen: !this.state.isTourOpen,
            steps: [
                {
                    placement: "center",
                    target: "body",
                    content: (
                        <div className="first-step-content">
                            <h4>Welcome to Dish Fiber!</h4>
                            <p>
                                Welcome to the DISH Fiber Wi-Fi management
                                portal here you can manager your Profiles,
                                devices and account details
                            </p>
                            <MDBInput
                                label="Do not show again"
                                type="checkbox"
                                id="tourNotShownAgain"
                                name="tourNotShownAgain"
                                onChange={this.toggleCheckboxValueTour}
                            />
                        </div>
                    ),
                },
                {
                    target: ".second-step",
                    content: (
                        <div className="second-step-content">
                            <h4>Profiles</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        minWidth: "400px",
                        textAlign: "center",
                    },
                },
                {
                    target: ".third-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Bandwidth</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        minWidth: "400px",
                        textAlign: "center",
                    },
                },
                {
                    target: ".devices-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Devices</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        minWidth: "400px",
                        textAlign: "center",
                    },
                },
                {
                    target: ".fourth-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Messages</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        minWidth: "400px",
                        textAlign: "center",
                    },
                },
                {
                    target: ".fifth-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Account Settings</h4>
                            <br />
                            <img src={MyAccount} alt="Account Settings" />
                        </div>
                    ),
                    styles: {
                        minWidth: "400px",
                        textAlign: "center",
                    },
                },
                {
                    placement: "center",
                    target: "body",
                    content: (
                        <div>
                            <p>Thank You!</p>
                            <MDBInput
                                label="Do not show again"
                                type="checkbox"
                                id="tourNotShownAgain"
                                name="tourNotShownAgain"
                                onChange={this.toggleCheckboxValueTour}
                            />
                            <MDBBtn color="danger" onClick={this.closeTour2}>
                                Close Tour
                            </MDBBtn>
                        </div>
                    ),
                },
            ],
            stepsMobile: [
                {
                    placement: "center",
                    target: "body",
                    content: (
                        <div className="first-step-content">
                            <h4>Welcome to Dish Fiber!</h4>
                            <p>
                                Welcome to the DISH Fiber Wi-Fi management
                                portal here you can manager your Propfiles,
                                devices and account details
                            </p>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    isFixed: true,
                },
                {
                    target: ".second-step",
                    content: (
                        <div className="second-step-content">
                            <h4>Profiles</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    placement: "bottom",
                },
                {
                    target: ".third-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Bandwidth</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    placement: "bottom",
                },
                {
                    target: ".devices-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Devices</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    isFixed: true,
                },
                {
                    target: ".fourth-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Messages</h4>
                            <p></p>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    placement: "top",
                },
                {
                    target: ".fifth-step",
                    content: (
                        <div className="third-step-content">
                            <h4>Account Settings</h4>
                            <br />
                            <img src={MyAccount} alt="Account Settings" />
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    isFixed: true,
                },
                {
                    placement: "center",
                    target: "body",
                    content: (
                        <div>
                            <p>Thank You!</p>
                            <MDBInput
                                label="Do not show again"
                                type="checkbox"
                                id="tourNotShownAgain"
                                name="tourNotShownAgain"
                                onChange={this.toggleCheckboxValueTour}
                            />
                            <MDBBtn color="danger" onClick={this.closeTour2}>
                                Close Tour
                            </MDBBtn>
                        </div>
                    ),
                    styles: {
                        textAlign: "center",
                    },
                    isFixed: true,
                },
                {
                    content: (
                        <div>
                            You can render anything!
                            <br />
                            <h3>Like this H3 title</h3>
                        </div>
                    ),
                    placement: "top",
                    target: ".demo__how-it-works h2",
                    title: "Our Mission",
                },
            ],
        });
    };
    setCurrentSlide = (curr) => {
        var p = document.getElementsByClassName("customClass");
        if (p[0] !== undefined && curr === 4) {
            if (p[0].classList.contains("active") === true) {
                p[0].classList.remove("active");
            }
        }
        if (p[0] !== undefined && curr === 5) {
            if (p[0].classList.contains("active") === false) {
                p[0].classList.add("active");
                return p[0].click();
            }
        }
    };
    toggleCheckboxValueTour = () => {
        this.setState({
            tourNotShownAgain: !this.state.tourNotShownAgain,
        });
    };
    showUpgradeModal = () => {
        this.setState({
            modalUpgrade: !this.state.modalUpgrade,
        });
    };
    onSignOutClick = () => {
        let element = document.getElementsByTagName("body")[0];
        element.setAttribute("data-theme", "darkMode-false");
        sessionStorage.clear();
        this.setState({ isLogged: false });
        window.location.href = "/";
    };
    // Support Chat Methods
    startConversation = async () => {
        try {
            this.setState({
                startButtonDisabled: true,
                errorVisible: false
            });
            // Show waiting message to user
            this.addMessage('agent', 'Please wait while we create your session. It may take up to 30 seconds.');
            // Prepare VAULT_ListKeys as a valid JSON object
            const vaultListKeys = this.state.listKeysResponse
                ? this.state.listKeysResponse
                : {};
            const response = await fetch(`${API_Server}/api/conversation/start`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    VAULT_ListKeys: vaultListKeys,
                    customerInfo: {
                        name: sessionStorage.getItem('firstName') + " " + sessionStorage.getItem('lastName') || 'Subscriber',
                        email: sessionStorage.getItem('emailSubscriber') || '',
                        phone: sessionStorage.getItem('phoneNumber') || '',
                        property: sessionStorage.getItem('venueNameSubscriber') || 'Unknown Property',
                        unit: sessionStorage.getItem('unitName') || 'Unknown Unit'
                    },
                    escalationEmail: sessionStorage.getItem('supportEmail') || '',
                })
            });
            const result = await response.json();
            if (result.success) {
                this.setState({
                    conversationId: result.data.conversationId,
                    currentState: result.data.state,
                    conversationInfoVisible: true,
                    chatInputVisible: true,
                    startButtonDisabled: false
                });
                this.addMessage('agent', result.data.message);
            } else {
                this.showError('Failed to start conversation: ' + result.error);
                this.setState({ startButtonDisabled: false });
            }
        } catch (error) {
            this.showError('Connection error. Please try again.');
            this.setState({ startButtonDisabled: false });
        }
    };
    sendMessage = async () => {
        const message = this.state.messageInput.trim();
        if (!message || !this.state.conversationId) return;
        try {
            this.setState({
                sendButtonDisabled: true,
                errorVisible: false,
                typingIndicatorVisible: true
            });
            // Add user message to chat
            this.addMessage('user', message);
            this.setState({ messageInput: '' });
            const response = await fetch(`${API_Server}/api/conversation/${this.state.conversationId}/message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ message })
            });
            const result = await response.json();
            console.log(result)
            this.setState({ typingIndicatorVisible: false });
            if (result.success) {
                this.addMessage('agent', result.data.message);
                this.setState({ currentState: result.data.state });
                // Check if conversation ended
                if (result.data.state === 'resolved' || result.data.state === 'escalated') {
                    this.endConversation(result.data);
                }
            } else {
                this.showError('Failed to send message: ' + result.error);
            }
        } catch (error) {
            this.setState({ typingIndicatorVisible: false });
            this.showError('Connection error. Please try again.');
        } finally {
            this.setState({ sendButtonDisabled: false });
        }
    };
    addMessage = (role, content) => {
        const newMessage = {
            id: Date.now(),
            role: role,
            content: content,
            timestamp: new Date().toLocaleTimeString()
        };
        this.setState(prevState => ({
            chatMessages: [...prevState.chatMessages, newMessage]
        }), () => {
            // Scroll to bottom after message is added
            this.scrollToBottom();
        });
    };
    scrollToBottom = () => {
        const chatMessages = document.getElementById('chatMessages');
        if (chatMessages) {
            setTimeout(() => {
                chatMessages.scrollTop = chatMessages.scrollHeight;
            }, 100);
        }
    };
    updateConversationInfo = (state) => {
        this.setState({
            currentState: state,
            conversationInfoVisible: true
        });
    };
    getStatusText = (state) => {
        const statusMap = {
            'greeting': 'Starting conversation',
            'collecting_info': 'Collecting information',
            'asking_about_issue': 'Understanding issue',
            'troubleshooting': 'Troubleshooting',
            'resolved': 'Issue resolved',
            'escalated': 'Escalated to Level 2'
        };
        return statusMap[state] || 'Active';
    };
    getStatusClass = (state) => {
        const classMap = {
            'greeting': 'status-active',
            'collecting_info': 'status-collecting',
            'asking_about_issue': 'status-collecting',
            'troubleshooting': 'status-troubleshooting',
            'resolved': 'status-resolved',
            'escalated': 'status-escalated'
        };
        return classMap[state] || 'status-active';
    };
    showChatInput = () => {
        this.setState({ chatInputVisible: true });
    };
    endConversation = (data) => {
        this.setState({
            sendButtonDisabled: true
        });
        if (data.ticketId) {
            setTimeout(() => {
                this.addMessage('agent', `Your support ticket ${data.ticketId} has been created for our Level 2 team.`);
            }, 1000);
        }
    };
    showTyping = () => {
        this.setState({ typingIndicatorVisible: true });
    };
    hideTyping = () => {
        this.setState({ typingIndicatorVisible: false });
    };
    showError = (message) => {
        this.setState({
            errorMessage: message,
            errorVisible: true
        });
    };
    hideError = () => {
        this.setState({ errorVisible: false });
    };
    handleMessageInputChange = (e) => {
        this.setState({ messageInput: e.target.value });
    };
    handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.sendMessage();
        }
    };
    autoResize = (element) => {
        if (element) {
            element.style.height = 'auto';
            element.style.height = Math.min(element.scrollHeight, 120) + 'px';
        }
    };
    // Check if current domain is allowed to show chat widget
    isChatAllowedDomain = () => {
        const hostname = window.location.hostname.toLowerCase();
        const allowedDomains = [
            'localhost',
            'devdd01.wifikey.link',
            'blueport.wifikey.io',
            'hyperleap.wifikey.io',
            'demo.roamingiq.com'
        ];
        
        // Check if domain is in allowed list
        if (!allowedDomains.includes(hostname)) {
            return false;
        }
        
        // For hyperleap, check if user email is in allowed list
        if (hostname === 'hyperleap.wifikey.io') {
            const userEmail = sessionStorage.getItem('emailSubscriber');
            if (!userEmail) {
                return false;
            }
            
            const allowedHyperleapEmails = [
                'tom@hyperleapnetwork.com',
                'alise@bdg.link',
                'andybrundell@gmail.com',
                'tnesper@roamingiq.com',
                'ed@roamingiq.com',
                'robert@bdg.link',
                'ddeslauriers@roamingiq.com',
                'tyler@hyperleapnetwork.com',
                'blake@hyperleapnetwork.com',
                'abragg@hyperleapnetwork.com',
                'chad.brown@circumferencegroup.com'
            ];
            
            return allowedHyperleapEmails.includes(userEmail.toLowerCase());
        }
        
        // For demo.roamingiq.com, check if user email is in allowed list
        if (hostname === 'demo.roamingiq.com') {
            const userEmail = sessionStorage.getItem('emailSubscriber');
            if (!userEmail) {
                return false;
            }
            
            const allowedDemoEmails = [
                'tnesper@roamingiq.com',
                'ddeslauriers@roaming.com'
            ];
            
            return allowedDemoEmails.includes(userEmail.toLowerCase());
        }
        
        return true;
    };

    render() {
        const { t } = this.props;
        console.log("this.state.SessionList", this.state.SessionList);
        // eslint-disable-next-line no-unused-vars
        let brandName;
        let showUpgrade;
        let phoneNumber;
        let emailAddress;
        brandsData.forEach(
            ({ name, url, phone_number, flag_upgrade, email_address }) => {
                if (url.includes(window.location.hostname)) {
                    brandName = name;
                    showUpgrade = flag_upgrade;
                    phoneNumber = phone_number;
                    emailAddress = email_address;
                }
            }
        );
        let newPrice;
        // console.log(this.state.BillingCyclePrice)
        if (
            this.state.BillingCyclePrice !== undefined &&
            this.state.UpgradeBillingCyclePrice !== undefined
        ) {
            newPrice =
                this.state.UpgradeBillingCyclePrice.toFixed(2) -
                this.state.BillingCyclePrice.toFixed(2);
        }
        // console.log(newPrice)
        return (
            <>
                <ToastContainer
                                hideProgressBar={true}
                                newestOnTop={true}
                                autoClose={10000}
                            />
                <div ref={(el) => (this.div = el)}></div>
                <MDBModal
                    isOpen={this.state.modalUpgrade}
                    toggle={this.showUpgradeModal}
                    centered
                >
                    <MDBModalHeader
                        toggle={this.showUpgradeModal}
                        className="noBorder"
                    ></MDBModalHeader>
                    <MDBModalBody className="updatePayment">
                        <h2>Modify Service Plan Feature Coming Soon</h2>
                        <p>
                            In order to process your request please contact our
                            Customer Support team at {phoneNumber} or send us an
                            email to{" "}
                            <a href={"mailto:" + emailAddress}>
                                {emailAddress}
                            </a>
                            , with your information and desired speed to
                            complete the change for your account.
                        </p>
                    </MDBModalBody>
                </MDBModal>
                {this.state.paymentFailed === true ? (
                    <MDBModal isOpen={true} centered toggle={() => {}}>
                        <MDBModalBody className="updatePayment">
                            <h2>
                                We encountered a problem processing your
                                payment.
                            </h2>
                            {/* <p>
                Please{" "}
                <a href="/update/checkout?ui=myaccount">click here</a> to update your payment information.
							       </p> */}
                            <p>
                                If you have any questions, contact support at{" "}
                                {sessionStorage.getItem("supportPhone")}.
                            </p>
                            <button className="button-danger Ripple-parent">
                                <a
                                    href="/update/checkout?ui=myaccount"
                                    rel="noreferrer"
                                >
                                    Update Payment Info
                                </a>
                            </button>
                            <button
                                className="button-danger Ripple-parent"
                                onClick={this.onSignOutClick}
                            >
                                Log Out & Update Later
                            </button>
                        </MDBModalBody>
                    </MDBModal>
                ) : (
                    ""
                )}
                {!this.state.loading && 
                 this.state.paymentFailed !== true && 
                 (!this.state.sortedKeys || this.state.sortedKeys.length === 0) ? (
                    <MDBModal isOpen={true} centered toggle={() => {}}>
                        <MDBModalBody className="updatePayment">
                            <h2>No active service found</h2>
                            <p>
                                Your account is signed in, but there is no active service for this account.
                            </p>
                            <p>
                                Please return to the sign-up process you used to originally activate your service.
                            </p>
                            <p>
                                <strong>To Contact Support:</strong>
                                {sessionStorage.getItem("supportPhone") && (
                                    <span> {sessionStorage.getItem("supportPhone")}</span>
                                )}
                                {sessionStorage.getItem("supportEmail") && (
                                    <span> or <a href={"mailto:" + sessionStorage.getItem("supportEmail")}>
                                        {sessionStorage.getItem("supportEmail")}
                                    </a></span>
                                )}
                            </p>
                            <button
                                className="button-danger Ripple-parent"
                                onClick={this.onSignOutClick}
                            >
                                Log Out
                            </button>
                        </MDBModalBody>
                    </MDBModal>
                ) : (
                    ""
                )}
                {this.state.loading === true ? (
                    <div id="overlay" style={{ display: "block" }}>
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div
                            id="subscriberUI"
                            className={
                                this.state.paymentFailed === true || 
                                (!this.state.loading && !this.state.sortedKeys || this.state.sortedKeys?.length === 0)
                                    ? "blurred"
                                    : ""
                            }
                            data-theme={
                                "darkMode-" + localStorage.getItem("darkMode")
                            }
                        >
                            {/* <Joyride
								steps={windowWidth > 767 ? steps : stepsMobile}
								run={this.state.isTourOpen}
								continuous={true}
								showProgress={true}
								styles={{
									options: {
										beaconSize: 1,
									},
								}}
								scrollDuration={500}
							/> */}
                            <Navigation
                                allData={this.state.allData}
                                listKeys={this.listKeys}
                                SessionList={this.state.SessionList}
                                keys={this.state.keys}
                                venueName={this.state.venueName}
                                closeTour={this.closeTour}
                                handleSwitchChange={this.handleSwitchChange}
                                darkMode={this.state.darkMode}
                                UpgradeServicePlanName={
                                    this.state.UpgradeServicePlanName
                                }
                                showSupport={this.state.showSupport}
                                isUbiquiti={this.state.isUbiquiti}
                                externalSupport={this.state.externalSupport}
                                externalSupportLink={this.state.externalSupportLink}
                                showCancel={this.state.showCancel}
                            />
                            {Object.keys(this.state.messages).length !== 0 &&
                            Object.keys(this.state.messages).some(key => 
                                this.state.messages[key]["newMessage"] !== false
                            ) ? (
                                <MDBModal
                                    isOpen={this.state.modalMessage}
                                    toggle={this.toggleMessage}
                                    centered
                                >
                                    <MDBModalHeader toggle={this.toggleMessage}>
                                        Messages
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <MDBRow className="messageSubject">
                                            <MDBCol>
                                                <p>Subject:</p>
                                                {
                                                    this.state.messages[
                                                        Object.keys(
                                                            this.state.messages
                                                        ).find(key => 
                                                            this.state.messages[key]["newMessage"] !== false
                                                        )
                                                    ]["Subject"]
                                                }
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol>
                                                <p>Message:</p>
                                                {parse(
                                                    this.state.messages[
                                                        Object.keys(
                                                            this.state.messages
                                                        ).find(key => 
                                                            this.state.messages[key]["newMessage"] !== false
                                                        )
                                                    ]["Message"]
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <MDBBtn
                                            color="danger"
                                            onClick={(e) =>
                                                this.submitConfirmMessage(
                                                    Object.keys(
                                                        this.state.messages
                                                    ).find(key => 
                                                        this.state.messages[key]["newMessage"] !== false
                                                    )
                                                )
                                            }
                                        >
                                            Acknowledge
                                        </MDBBtn>
                                    </MDBModalFooter>
                                </MDBModal>
                            ) : null}
                            {showUpgrade &&
                            this.state.UpgradeServicePlanName !== undefined &&
                            window.location.pathname === "/myaccount" &&
                            newPrice !== 0 &&
                            newPrice !== undefined ? (
                                <div
                                    className={
                                        "topBanner " +
                                        this.state.toggleNotifications
                                    }
                                >
                                    <h2>
                                        You are on the{" "}
                                        {this.state.ServicePlanName} plan,{" "}
                                        <a href="/myaccount/upgrade">
                                            Click here
                                        </a>{" "}
                                        to upgrade to{" "}
                                        {this.state.UpgradeServicePlanName} for
                                        only ${newPrice.toFixed(2)} more per
                                        month!
                                    </h2>
                                    <MDBIcon
                                        icon="times-circle"
                                        onClick={this.toggleNotifications}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                            {window.location.pathname ===
                            "/myaccount/upgrade" ? (
                                <Upgrade />
                            ) : window.location.pathname ===
                              "/myaccount/upgrade/review" ? (
                                <UpgradeReview />
                            ) : window.location.pathname ===
                              "/myaccount/upgrade/checkout" ? (
                                <UpgradeCheckout />
                            ) : window.location.pathname ===
                              "/myaccount/upgrade/paymentsuccess" ? (
                                <UpgradePaymentSuccess />
                            ) : window.location.pathname ===
                              "/myaccount/cancel" ? (
                                <Cancel />
                            ) : (
                                <div className="mainDashboard subscriberUIDashboard">
                                    <MDBContainer fluid>
                                        <MDBRow className="dashboardRow">
                                            <MDBCol
                                                sm="12"
                                                xl="6"
                                                className="second-step dashboardCard"
                                            >
                                                {this.state.sortedKeys !== undefined && this.state.sortedKeys.length > 0 ? (
                                                    <KeyInformation
                                                        listKeys={this.listKeys}
                                                        SessionList={
                                                            this.state
                                                                .SessionList
                                                        }
                                                        keys={this.state.keys}
                                                        sortedKeys={
                                                            this.state
                                                                .sortedKeys
                                                        }
                                                        venueName={
                                                            this.state.venueName
                                                        }
                                                        keyNameListArray={
                                                            this.state
                                                                .keyNameListArray
                                                        }
                                                        keyNameListArrayAll={
                                                            this.state
                                                                .keyNameListArrayAll
                                                        }
                                                        loading={
                                                            this.state.loading
                                                        }
                                                        selectedKeyID={
                                                            this.state
                                                                .selectedKeyID
                                                        }
                                                        token={this.state.token}
                                                        venueUnitPolicies={
                                                            this.state
                                                                .venueUnitPolicies
                                                        }
                                                        allVenueUnitPolicies={
                                                            this.state
                                                                .allVenueUnitPolicies
                                                        }
                                                        keysAndVenueUnitPoliciesArray={
                                                            this.state
                                                                .keysAndVenueUnitPoliciesArray
                                                        }
                                                        subscriberToken={
                                                            this.state
                                                                .subscriberToken
                                                        }
                                                        isUbiquiti={
                                                         this.state.isUbiquiti
                                                        }
                                                        selectedKeyName={
                                                            this.state.selectedKeyName
                                                        }
                                                        selectedNetworkIndex={
                                                            this.state.selectedNetworkIndex
                                                        }
                                                    />
                                                ) : (
                                                    <>
                                                        <div
                                                            className="ctaButtonNoAction"
                                                            onClick={
                                                                this
                                                                    .toggleManageProfiles
                                                            }
                                                        >
                                                            <h2>
                                                                <MDBIcon icon="wifi" />{" "}
                                                                {t(
                                                                    "profile.title"
                                                                )}
                                                            </h2>
                                                        </div>
                                                        <MDBCard
                                                            style={{
                                                                display: "flex",
                                                                justifyContent:
                                                                    "center",
                                                                alignItems:
                                                                    "center",
                                                                minHeight:
                                                                    "230px",
                                                                marginBottom:
                                                                    "20px",
                                                            }}
                                                        >
                                                            <MDBCardBody
                                                                className="messageCardBody1 dashboardCard"
                                                                style={{
                                                                    flex: "unset",
                                                                }}
                                                            >
                                                                <h4
                                                                    style={{
                                                                        color: "#BBB",
                                                                    }}
                                                                >
                                                                    {t(
                                                                        "profile.nokeys"
                                                                    )}
                                                                </h4>
                                                            </MDBCardBody>
                                                        </MDBCard>
                                                    </>
                                                )}
                                            </MDBCol>
                                            {
                                             !this.state.isUbiquiti ? (
                                                <MDBCol
                                                    sm="12"
                                                    xl="6"
                                                    className="third-step dashboardCard"
                                                >
                                                    <CumulativeBandwidth
                                                        selectedKeyID={
                                                            this.props.selectedKeyID
                                                        }
                                                    />
                                                </MDBCol>
                                             ) : null
                                            }
                                            {
                                             !this.state.isUbiquiti ? (
                                                <MDBCol
                                                    sm="12"
                                                    xl="6"
                                                    className="devices-step dashboardCard"
                                                >
                                                    <DeviceInformation
                                                        deviceControlID={Object.keys(
                                                            this.state.devices
                                                        )}
                                                        devices={this.state.devices}
                                                        deviceCountOffline={
                                                            this.state
                                                                .deviceCountOffline
                                                        }
                                                        deviceCountOnline={
                                                            this.state
                                                                .deviceCountOnline
                                                        }
                                                        listKeys={this.listKeys}
                                                    />
                                                </MDBCol>
                                             ) : null
                                            }
                                            <MDBCol
                                                sm="12"
                                                xl="6"
                                                className="fourth-step dashboardCard"
                                            >
                                                <MessagesDashboard
                                                    messages={
                                                        this.state.messages
                                                    }
                                                    updateMessageStatus={this.updateMessageStatus}
                                                />
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBContainer>
                                </div>
                            )}
                            <div className="footer subscriberUI">
                                <MDBContainer fluid>
                                    <MDBRow>
                                        <MDBCol className="securedByVaultImage">
                                            <LogoFooter
                                                darkMode={localStorage.getItem(
                                                    "darkMode"
                                                )}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </div>
                        </div>
                        {/* Support Chat Widget - Rendered outside subscriberUI for proper z-index */}
                        {this.isChatAllowedDomain() && (
                        <div className="support-chat-widget" style={{ zIndex: 9999, position: 'fixed', bottom: '20px', right: '20px' }}>
                            {/* Chat Toggle Button */}
                            <div className="chat-toggle-container">
                                    <MDBBtn
                                        color="primary"
                                        size="lg"
                                        floating
                                        className={`chat-toggle-btn ${!this.state.conversationId ? 'pulse-animation' : ''}`}
                                        onClick={() => this.setState({ 
                                            supportChatOpen: !this.state.supportChatOpen 
                                        })}
                                        title="Need help? Chat with our AI support assistant!"
                                    >
                                        <MDBIcon 
                                            icon={this.state.supportChatOpen ? "times" : "comments"} 
                                            size="lg"
                                            className={!this.state.conversationId && !this.state.supportChatOpen ? "jumping-icon" : ""}
                                        />
                                    </MDBBtn>
                                    {/* Floating tooltip for first-time users */}
                                    {!this.state.conversationId && !this.state.supportChatOpen && (
                                        <div className="chat-floating-tooltip">
                                            <div className="tooltip-bubble">
                                                Talk to an agent!
                                                <div className="tooltip-arrow"></div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {/* Chat Window */}
                                {this.state.supportChatOpen && (
                                    <div className="chat-window">
                                        <div className="chat-header">
                                            <h5>
                                                <MDBIcon icon="headset" className="mr-2" />
                                                Support Chat
                                            </h5>
                                            {this.state.conversationInfoVisible && (
                                                <div className="conversation-info">
                                                    <small>
                                                        <span className={`status-indicator ${this.getStatusClass(this.state.currentState)}`}></span>
                                                        {this.getStatusText(this.state.currentState)}
                                                        {this.state.conversationId && (
                                                            <span className="ml-2">ID: {this.state.conversationId}</span>
                                                        )}
                                                    </small>
                                                </div>
                                            )}
                                        </div>
                                        <div className="chat-body">
                                            {/* Error Message */}
                                            {this.state.errorVisible && (
                                                <div className="alert alert-danger chat-error">
                                                    <MDBIcon icon="exclamation-triangle" className="mr-2" />
                                                    {this.state.errorMessage}
                                                </div>
                                            )}
                                            {/* Chat Messages */}
                                            <div className="chat-messages" id="chatMessages">
                                                {this.state.chatMessages.length === 0 && !this.state.conversationId ? (
                                                    <div className="welcome-message">
                                                        <MDBIcon icon="robot" size="2x" className="mb-3" />
                                                        <h6>Need Help?</h6>
                                                        <p>Start a conversation with our AI Support Assistant — it’s powered by AI and may connect you with our team if needed.</p>
                                                    </div>
                                                ) : (
                                                    this.state.chatMessages.map(message => (
                                                        <div key={message.id} className={`message ${message.role}`}>
                                                            <div className="message-content">
                                                                {message.content}
                                                            </div>
                                                            <div className="message-time">
                                                                {message.timestamp}
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                                {/* Typing Indicator */}
                                                {this.state.typingIndicatorVisible && (
                                                    <div className="typing-indicator">
                                                        <div className="message agent">
                                                            <div className="message-content">
                                                                <div className="typing-dots">
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {/* Chat Input */}
                                            <div className="chat-footer">
                                                {!this.state.conversationId ? (
                                                    <MDBBtn
                                                        color="primary"
                                                        block
                                                        onClick={this.startConversation}
                                                        disabled={this.state.startButtonDisabled}
                                                    >
                                                        {this.state.startButtonDisabled ? (
                                                            <>
                                                                <MDBIcon icon="spinner" spin className="mr-2" />
                                                                Starting...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <MDBIcon icon="play" className="mr-2" />
                                                                Start New Conversation
                                                            </>
                                                        )}
                                                    </MDBBtn>
                                                ) : (
                                                    <div className="chat-input-section">
                                                        <div className="input-group">
                                                            <div className="chat-input-wrapper">
                                                                <textarea
                                                                    className="form-control chat-textarea"
                                                                    placeholder="Type your message..."
                                                                    value={this.state.messageInput}
                                                                    onChange={this.handleMessageInputChange}
                                                                    onKeyPress={this.handleKeyPress}
                                                                    disabled={this.state.sendButtonDisabled}
                                                                    rows="1"
                                                                    ref={(el) => {
                                                                        if (el) this.autoResize(el);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="input-group-append">
                                                                <MDBBtn
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={this.sendMessage}
                                                                    disabled={this.state.sendButtonDisabled || !this.state.messageInput.trim()}
                                                                >
                                                                    {this.state.sendButtonDisabled ? (
                                                                        <MDBIcon icon="spinner" spin />
                                                                    ) : (
                                                                        <MDBIcon icon="paper-plane" />
                                                                    )}
                                                                </MDBBtn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }
}
export default withTranslation()(DashboardSubscriber);
